import { DEVELLO_API_ORIGIN, fetchWithAuth } from '../utils/asyncReliability';
import { supabase } from '../supabase';

export async function startProCheckout() {
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/billing/checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    name: 'billing:checkout',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });
  if (!res.ok) throw new Error(res.userMessage || 'Checkout failed');
  const body = /** @type {{ url?: string }} */ (res.data || {});
  if (!body.url) throw new Error('No checkout URL returned');
  window.location.href = body.url;
}

export async function openBillingPortal() {
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/billing/portal`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    name: 'billing:portal',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });
  if (!res.ok) throw new Error(res.userMessage || 'Could not open billing portal');
  const body = /** @type {{ url?: string }} */ (res.data || {});
  if (!body.url) throw new Error('No portal URL returned');
  window.location.href = body.url;
}

export async function fetchBillingSummary() {
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/billing/summary`, {
    name: 'billing:summary',
    timeoutMs: 35000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });
  if (!res.ok) throw new Error(res.userMessage || 'Summary failed');
  return res.data;
}

export async function syncCheckoutSession(sessionId) {
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/billing/sync-checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId }),
    name: 'billing:syncCheckout',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });
  if (!res.ok) throw new Error(res.userMessage || 'Sync failed');
  return res.data;
}

export async function endTrial() {
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/billing/end-trial`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
    name: 'billing:endTrial',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });
  if (!res.ok) throw new Error(res.userMessage || 'Could not end trial');
  return res.data;
}

/** Cancel Stripe subscription (default: at end of period). */
export async function cancelStripeSubscription(options = {}) {
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/billing/cancel-subscription`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ immediate: Boolean(options.immediate) }),
    name: 'billing:cancelSubscription',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });
  if (!res.ok) throw new Error(res.userMessage || 'Cancel failed');
  return res.data;
}

/** Undo cancel_at_period_end on the active subscription. */
export async function reactivateStripeSubscription() {
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/billing/reactivate-subscription`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
    name: 'billing:reactivateSubscription',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });
  if (!res.ok) throw new Error(res.userMessage || 'Reactivate failed');
  return res.data;
}
